// extracted by mini-css-extract-plugin
export default {"qrCodeWrapper":"styles_qrCodeWrapper__EJpGx","socialMediaIcon":"styles_socialMediaIcon__r2oF3","qrCodeIcon":"styles_qrCodeIcon__efA9T"};